/* eslint-disable react-hooks/exhaustive-deps */
import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";

import AutoComplete from "@/components/hookForms/autoComplete";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import InputNumber from "@/components/hookForms/inputNumber";
import TextField from "@/components/hookForms/textField";
import serviceParametrizacao from "@/services/serviceParametrizacao";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data: {
        contextoOptions: any;
        concessionariaDataOptions: any;
    };
}

export default function DialogNew({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [nomeParametroOptions, setNomeParametroOptions] = useState<any[]>([]);
    const [selectedParameter, setSelectedParameter] = useState<any>({});
    const [listValues, setListValues] = useState<any[]>([]);

    const validationSchema = yup.object().shape({
        concessionariaID: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        nomeParametro: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        valor:
            selectedParameter?.campoAberto === "S" && selectedParameter?.tipo === "Texto"
                ? yup
                      .string()
                      .matches(/^[0-9.,;%-]*$/, "Formato Inválido!")
                      .required(messages.requiredField)
                : yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            concessionariaID: "",
            descricao: "",
            valorPadrao: "",
            valor: "",
            nomeParametro: "",
            tipo: "",
            campoAberto: "",
            valoresPossiveis: "",
        },
    });

    useEffect(() => {
        if (open && selectedParameter?.campoAberto === "N") {
            if (selectedParameter?.tipo !== "SimNao") {
                const elems = selectedParameter?.valoresPossiveis.split(";");

                let b: any[] = [];
                b = elems.reduce((newArray, currentValue) => {
                    newArray.push({ value: currentValue, label: currentValue });
                    return newArray;
                }, b);
                setListValues(b);
            } else {
                setListValues([
                    { label: "Sim", value: "Sim" },
                    { label: "Não", value: "Não" },
                ]);
            }
        }
    }, [selectedParameter]);

    const setNomeParametroData = async () => {
        serviceParametrizacao
            .getNomes()
            .then((result) => setNomeParametroOptions(result?.data))
            .catch(() => {
                setNomeParametroOptions([]);
            });
    };

    useEffect(() => {
        setNomeParametroData();
    }, []);

    const onSubmit = (values: any) => {
        setDisable(true);

        delete values.valorPadrao;
        delete values.descricao;

        const newItem = {
            ...values,
        };

        serviceParametrizacao
            .create(newItem)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose();
                    setSelectedParameter("");
                    setListValues([]);
                    reset({
                        concessionariaID: "",
                        descricao: "",
                        valorPadrao: "",
                        valor: "",
                        nomeParametro: "",
                        tipo: "",
                        campoAberto: "",
                        valoresPossiveis: "",
                    });
                }
            })
            .catch((err) => {
                toast.error(messages.createSucess, err);
            })
            .finally(() => {
                setDisable(false);
                onSuccess();
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Novo Parâmetro
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            setSelectedParameter("");
                            setListValues([]);
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <AutoComplete
                                id="formNewNomeParametro"
                                name="nomeParametro"
                                label="Nome"
                                options={nomeParametroOptions?.map((data) => {
                                    return { label: data.nomeParametro, value: data.nomeParametro };
                                })}
                                onChange={(nome) => {
                                    const data = nomeParametroOptions.find((value) => value.nomeParametro === nome);
                                    setSelectedParameter(data);
                                    reset({
                                        descricao: data?.descricao ?? "",
                                        valorPadrao: data?.valor ?? "",
                                        nomeParametro: data?.nomeParametro ?? "",
                                        tipo: data?.tipo ?? "",
                                        campoAberto: data?.campoAberto ?? "",
                                        valoresPossiveis: data?.valoresPossiveis ?? "",
                                    });
                                }}
                                onInputChange={(_, __, reason) => {
                                    if (reason === "clear") {
                                        reset({
                                            descricao: "",
                                            valorPadrao: "",
                                            nomeParametro: "",
                                            tipo: "",
                                            campoAberto: "",
                                            valoresPossiveis: "",
                                        });
                                        setListValues([]);
                                    }
                                }}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                id="formNewValorPadrao"
                                name="valorPadrao"
                                label="Valor Padrão"
                                control={control}
                                error={errors}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextInput
                                id="formNewDescricao"
                                name="descricao"
                                label="Descrição"
                                control={control}
                                error={errors}
                                disabled
                                multiline={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <AutoComplete
                                id="formNewConcessionariaID"
                                name="concessionariaID"
                                label="Concessionária"
                                options={data.concessionariaDataOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {selectedParameter?.campoAberto === "S" ? (
                                selectedParameter?.tipo === "Texto" ? (
                                    <TextField
                                        id="formNewValor"
                                        name="valor"
                                        label="Valor"
                                        control={control}
                                        error={errors}
                                        maxLength={30}
                                    />
                                ) : (
                                    <InputNumber
                                        id="formNewValor"
                                        name="valor"
                                        label="Valor"
                                        control={control}
                                        error={errors}
                                        noThousandSeparator
                                        maxLength={20}
                                    />
                                )
                            ) : (
                                <AutoComplete
                                    id="formNewValor"
                                    name="valor"
                                    label="Valor"
                                    options={listValues}
                                    control={control}
                                    error={errors}
                                />
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        id="cancelar"
                        onClick={() => {
                            reset({
                                concessionariaID: "",
                                descricao: "",
                                valorPadrao: "",
                                valor: "",
                                nomeParametro: "",
                                tipo: "",
                                campoAberto: "",
                                valoresPossiveis: "",
                            });
                            setSelectedParameter("");
                            setListValues([]);
                            onClose(true);
                        }}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        id="salvar"
                        type="submit"
                        color="primary"
                        variant="contained"
                        loading={isDisable}
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </LoadingButton>
                </DialogActions>
            </form>
        </Dialog>
    );
}
